import Table from '@/components/common/Table'
import { Container, SearchInput, SearchIcon, Button, IconSvg, HeaderWrapper } from './styles'
import { IMAGE_URL } from '@/constant/IMAGE'
import AutoAssignTableHook from './AutoAssignTable.hook'
import DeleteAutoAssignModal from '../DeleteAutoAssignModal'
import ModalAddTeamMember from '../components/ModalAddAutoAssignMember/ModalAddAutoAssignMember'

const AutoAssignTable = () => {
  const { columns, queryListAutoAssignee, onTableChange, onSearch, handleAddUser } =
    AutoAssignTableHook()

  return (
    <Container>
      <HeaderWrapper>
        <SearchInput
          id="auto-assign-search"
          placeholder="ค้นหาชื่อ, นามสกุล, รหัสพนักงาน"
          prefix={<SearchIcon />}
          data-testid="auto-assign-search-input"
          onChange={onSearch}
        />
        <Button
          type="primary"
          icon={<IconSvg src={IMAGE_URL.plusIcon} />}
          data-testid="campaign-management-add-campaign-button"
          onClick={handleAddUser}
        >
          เพิ่มผู้ใช้งาน
        </Button>
      </HeaderWrapper>
      <Table
        columns={columns}
        dataSource={queryListAutoAssignee.data?.data}
        loading={queryListAutoAssignee.isLoading}
        pagination={{
          pageSizeOptions: [10, 25, 50, 100],
          showSizeChanger: true,
          total: queryListAutoAssignee.data?.meta.totalItems,
          current: queryListAutoAssignee.data?.meta.currentPage,
          defaultCurrent: 1,
          defaultPageSize: 10,
          pageSize: queryListAutoAssignee.data?.meta.itemsPerPage,
        }}
        onChange={(pagination) => onTableChange(pagination)}
      />
      <DeleteAutoAssignModal />
      <ModalAddTeamMember />
    </Container>
  )
}

export default AutoAssignTable
